import React from 'react';
import { FormControlBackgroundColorPicker } from './FormControlBackgroundColorPicker.js';
import { FormControlButtonGroupSelect } from './FormControlButtonGroupSelect.js';
import { FormControlCheckbox } from './FormControlCheckbox.js';
import { FormControlInput } from './FormControlInput.js';
import { FormControlInputCopy } from './FormControlInputCopy.js';
import { FormControlLayout } from './FormControlLayout.js';
import { FormControlMeta } from './FormControlMeta.js';
import { FormControlMultiselect } from './FormControlMultiselect.js';
import { FormControlRadioGroup } from './FormControlRadioGroup.js';
import { FormControlSearchableSelect } from './FormControlSearchableSelect.js';
import { FormControlSelect } from './FormControlSelect.js';
import { FormControlSlider } from './FormControlSlider.js';
import { FormControlTextarea } from './FormControlTextarea.js';
import { FormControlToggle } from './FormControlToggle.js';
import { HelperText } from './HelperText.js';
import { Label } from './Label.js';
export const FormControl = ({ children }) => (React.createElement("div", { className: "space-y-1" }, children));
FormControl.Label = Label;
FormControl.HelperText = HelperText;
FormControl.Meta = FormControlMeta;
FormControl.Layout = FormControlLayout;
FormControl.Input = FormControlInput;
FormControl.InputCopy = FormControlInputCopy;
FormControl.Checkbox = FormControlCheckbox;
FormControl.Textarea = FormControlTextarea;
FormControl.Toggle = FormControlToggle;
FormControl.Select = FormControlSelect;
FormControl.Multiselect = FormControlMultiselect;
FormControl.RadioGroup = FormControlRadioGroup;
FormControl.SearchableSelect = FormControlSearchableSelect;
FormControl.Slider = FormControlSlider;
FormControl.ButtonGroupSelect = FormControlButtonGroupSelect;
FormControl.BackgroundColorPicker = FormControlBackgroundColorPicker;
//# sourceMappingURL=FormControl.js.map